module.exports = "<router-outlet></router-outlet>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app.component.html
 ** module id = 60
 ** module chunks = 0
 **/